export default __webpack_public_path__ + "static/circle-1-inverted-a56c4f6b7d2be261666a0047605ed31f.png";